<template>
    <div>
        <div class="mini-card">
            <el-card>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <h2>{{ product.name }}</h2>
                        <div class="info-identity">
                            <p><span>{{ $t('product_id') }}: </span><span class="data-display">{{ product.id }}</span></p>
                            <p><span>{{ $t('product_name') }}: </span><span class="data-display">{{ product.name }}</span></p>
                            <p><span>{{ $t('product_type') }}: </span><span class="data-display">{{ product.type }}</span></p>
                            <p><span>{{ $t('associated_beacon_id') }}: </span><span class="data-display">{{ product.beaconId }}</span></p>
                        </div>
                        <el-row>
                            <el-tooltip class="item" effect="dark" :content="$t('edit')" placement="top">
                                <el-button v-if="isSuperAdmin" type="primary" icon="el-icon-edit" @click="editProduct" circle></el-button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" :content="$t('duplicate')" placement="top">
                                <el-button v-if="isSuperAdmin" type="primary" icon="el-icon-document-copy" @click="duplicateProduct" circle></el-button>
                            </el-tooltip>
                        </el-row>
                    </el-col>
                </el-row>
            </el-card>
        </div>
        <!-- start Modal for Create OF form -->
        <el-dialog
            width="1200px"
            :visible.sync="dialogFormVisible"
            :modalAppendToBody="false">
            <CreateProduct
              :formStateModal="productFormType"
              :productSelected="product"
              :key="dialogFormVisible"
              @closeForm="closeForm">
            </CreateProduct>
        </el-dialog>
        <!-- end Modal for Create OF form -->
    </div>
</template>

<script>
import CreateProduct from '../components/product/CreateProduct.vue'
import DateTimeManipulation from '../mixins/DateTimeManipulation'

export default {
    components: {
        CreateProduct
    },
    props: {
        product: {
            type: Object,
        }
    },
    data() {
        return {
            productFormType: 'edit',
            dialogFormVisible: false,
            isSuperAdmin: false,
        }
    },
    created() {
        this.isSuperAdmin = this.$store.getters.isSuperAdmin;
    },
    methods: {
        editProduct: function() {
            console.log('this.product: ', this.product);
            this.productFormType = 'edit';
            this.dialogFormVisible = true;
        },
        duplicateProduct: function() {
            this.productFormType = 'duplicate';
            this.dialogFormVisible = true;
        },
        closeForm: function() {
            this.dialogFormVisible = false;
            this.$emit('closeForm', false);
        },
    },
    mixins: [DateTimeManipulation]
}
</script>

<style scoped>
    h3 {
        color: white;
    }

    .mini-card {
        margin-bottom: 20px;
    }

    .table-card {
        background-color: var(--color1light);
        padding: 10px;
        border-radius: 12px;
    }

    .info-identity {
        margin-bottom: 24px;

    }

    .info-identity > p {
        margin: 5px;
    }

    .data-display {
        font-weight: bold;
    }
</style>